import React, { useEffect, useMemo } from "react";
import { Form, Table, Checkbox, Typography, Flex } from "antd";
import { useParams } from "react-router-dom";
import useData from "../../../hooks/useData";
import NumberFormat from "../../../utils/NumberFormat";

const { Title } = Typography;

const PurchaseForm = () => {
  const { id } = useParams();
  const { data: request } = useData(`/purchase/id?id=${id}`, []);
  const { data: dealers } = useData("/products/dealers", []);

  const items = useMemo(() => {
    if (!request) return [];
    return request.products;
  }, [request]);

  useEffect(() => {
    if (!request.products) return;
    setTimeout(() => {
      window.print();
    }, 800);
  }, [request]);

  return (
    <div style={{ maxWidth: "100vw", margin: "0 auto", padding: 0 }}>
      <Title level={4}>Форма Закупки</Title>
      <Form layout="vertical">
        <Form.Item label="Дата закупки">
          <div
            style={{
              width: "100%",
              height: 45,
              border: "1px solid #cac9c9",
              background: "#fff",
            }}
          />
        </Form.Item>
      </Form>
      <Table dataSource={items} pagination={false} rowKey="key" size={"small"}>
        <Table.Column
          title=""
          key="purchased"
          width={30}
          render={(text, record) => <Checkbox checked={record.purchased} />}
        />
        <Table.Column
          title="Наименование"
          dataIndex="name"
          key="name"
          render={(t, v) => (
            <Flex gap={12} align={"center"}>
              {v?.file ? (
                <img
                  src={v.file}
                  width={32}
                  height={32}
                  style={{
                    background: "#FFF",
                    maxWidth: "100%",
                    height: "auto",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    padding: 2,
                  }}
                />
              ) : null}
              <Flex vertical>
                <div>{v.name}</div>
                <span style={{ fontSize: 12, color: "#999" }}>{v.code}</span>
              </Flex>
            </Flex>
          )}
        />
        <Table.Column title="Кол-во" dataIndex="quantity" key="quantity" />
        <Table.Column
          title="Магазин"
          dataIndex="dealer"
          key="dealer"
          render={(text) => dealers.find((d) => d._id === text)?.name}
        />
        <Table.Column
          title="Цена"
          dataIndex="price"
          key="price"
          render={(text, record) => `${NumberFormat(record.price)}`}
        />
        <Table.Column
          title="Сумма"
          key="total"
          render={(text, record) =>
            `${NumberFormat(record.quantity * record.price)}`
          }
        />
        <Table.Column
          title="Примечание"
          dataIndex="comment"
          key="comment"
          render={(text) => text || "-"}
        />
      </Table>
      <Title level={4} style={{ marginTop: 20 }}>
        Итого: {NumberFormat(request?.totalAmount)} ₾
      </Title>
    </div>
  );
};

export default PurchaseForm;
